/**
 * Normaliza um valor para [0, 1] dentro do domínio [min, max] do heatmap.
 * min ≠ 0 permite variáveis com domínio negativo (ex. saldo_bh, mm com
 * sinal); com min = 0 reproduz exatamente o comportamento original (v/max).
 */
export default function normalizeHeatT(value: number, min: number, max: number): number {
  if (max <= min) return 0;
  return Math.min(1, Math.max(0, (value - min) / (max - min)));
}
